import React from 'react'
import {Link} from 'react-router-dom';
import Popover from './Popover.tsx';
import { useDispatch, useSelector } from 'react-redux';
import { translate } from '../i18n';

const UserPopover = () => {
  const dispatch = useDispatch();
  const language_code = useSelector((state) => state.lang)
  return (
    <>
    <Popover preferredPosition="bottom-center">
                <Popover.Trigger>
                <p className="mb-0">{translate('agro_main_header', language_code.lang).account1} 
                  <br/>{translate('agro_main_header', language_code.lang).account2}</p>
                </Popover.Trigger>
                <Popover.Content className='account-popover'>
                 <div className='d-flex flex-column py-3'>
                  <div className='d-flex flex-column justify-content-center align-items-center getting-started'>
                    <Link className='button' to='/login'>
                    <Popover.Close>
                        <button className='popover-close' to="/login">Identifiez-vous</button>
                    </Popover.Close>   
                    </Link>
                    <div className='d-flex mt-2'>
                        <p className='small-text' to='/signup'>Nouveau client ?</p>&nbsp;
                        <Popover.Close className='small-text'>
                            <Link className='user-popover-link' to='/signup'>Commencez ici</Link>
                        </Popover.Close>
                    </div>
                  </div>

                  <div className='d-flex explorer'>
                  <div className='d-flex flex-column justify-content-begin m-2 left'>
                   <h5 className='user-popover-title'>Votre compte</h5>
                    <ul className="p-0" aria-labelledby="dropdownMenuButton1">
                      <li><Link className="user-popover-link" to="/signup1">Votre compte</Link></li>
                        <li><Link className="user-popover-link" to="">Adhésions et abonnements</Link></li>
                        <li><Link className="user-popover-link" to="">Votre liste de favories</Link></li>
                        <li><Link className="user-popover-link" to="">Vos recommendations</Link></li>
                        <li><Link className="user-popover-link" to="">Votre compte Assiganto Entreprise</Link></li>
                        <li><Link className="user-popover-link" to="">Votre compte Agri Hero</Link></li>
                      <li><Link className="user-popover-link" to="">Vos commandes</Link></li>
                      <li><Link className="user-popover-link" to="">Vos livraisons programmées</Link></li>
                      <li><Link className="user-popover-link" to="">Gerer vos agents de terrain</Link></li>
                      <li><Link className="user-popover-link" to="">Créer un compte Entreprise gratuit</Link></li>
                    </ul>
                   </div>
                   <div className='d-flex flex-column justify-content-begin m-2 right'>
                   <h5 className='user-popover-title'>Vos forfaits</h5>
                    <ul className="p-0" aria-labelledby="dropdownMenuButton1">
                      <li><Link className="user-popover-link" to="">Vos forfaits et services</Link></li>
                        <li><Link className="user-popover-link" to="">Ajouter forfaits et services</Link></li>
                        <li><Link className="user-popover-link" to="">Forfait agriculture assistée par l'IA</Link></li>
                      <li><Link className="user-popover-link" to="">Liste d'achat saisonnier</Link></li>
                      <li><Link className="user-popover-link" to="">Liste de matiere premiere</Link></li>
                      <li><Link className="user-popover-link" to="">Explorer les services</Link></li>
                    </ul>
                   </div>
                 </div> 

                 </div>
                </Popover.Content>
              </Popover>
    </>
  )
}

export default UserPopover